module.exports = __webpack_public_path__ + "img/daniel_gunther.236a4f4f.png";